import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    PhoneOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { UserShort } from "tm-shared/types";

import FlexContainer from "@/components/FlexContainer";
import { PrimaryText } from "@/components/Typography/Styled";

import {
    StyledMemberInfoContainer,
    StyledPhoneLink,
    StyledWorkStatus,
} from "../../Styled";

interface MemberInfoProps {
    member: UserShort;
}

export const MemberInfo = ({ member }: MemberInfoProps) => {
    return (
        <StyledMemberInfoContainer>
            <FlexContainer
                gap="6px"
                alignItems="flex-start"
                justifyContent="flex-start"
            >
                <PrimaryText>{member.fullName}</PrimaryText>
            </FlexContainer>

            <StyledWorkStatus>
                {member.isWorking ? (
                    <>
                        <CheckCircleOutlined />
                        Почав о {dayjs(member.startedAt).format("H:mm")}
                    </>
                ) : (
                    <>
                        <ClockCircleOutlined />
                        Не на роботі
                    </>
                )}
            </StyledWorkStatus>

            <StyledPhoneLink href={`tel:${member.phone}`}>
                <PhoneOutlined />
                {member.phone}
            </StyledPhoneLink>
        </StyledMemberInfoContainer>
    );
};
